import supabase from "@/services/supabaseClient";

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;

function normalizeUuid(value) {
  const clean = String(value || "").trim();
  return UUID_RE.test(clean) ? clean : "";
}

function normalizeIso(value) {
  const date = new Date(value || "");
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}

function normalizeDecision(value) {
  const decision = String(value || "").trim().toLowerCase();
  return decision === "approve" || decision === "reject" ? decision : "";
}

export function appointmentChangeRequestIdFromNotificationType(type) {
  const parts = String(type || "").trim().split(":");
  if (parts.length < 3) return "";
  if (parts[0] !== "appointment_reschedule_request") return "";
  return normalizeUuid(parts[2] || "");
}

export async function submitPatientAppointmentChangeRequest({
  appointmentId,
  proposedAppointmentDate,
  consultationType,
  correlationId = null,
} = {}) {
  const cleanAppointmentId = normalizeUuid(appointmentId);
  const cleanProposedDate = normalizeIso(proposedAppointmentDate);
  if (!cleanAppointmentId || !cleanProposedDate) {
    throw new Error("Missing appointment change request context.");
  }

  const { data, error } = await supabase.rpc("afrimed_submit_patient_appointment_change_request", {
    p_appointment_id: cleanAppointmentId,
    p_proposed_appointment_date: cleanProposedDate,
    p_consultation_type: String(consultationType || "").trim() || null,
    p_correlation_id: String(correlationId || "").trim() || null,
  });
  if (error) throw error;
  return data || null;
}

export async function decidePatientAppointmentChange({ requestId, decision, correlationId = null } = {}) {
  const cleanRequestId = normalizeUuid(requestId);
  const cleanDecision = normalizeDecision(decision);
  if (!cleanRequestId || !cleanDecision) {
    throw new Error("Missing appointment change decision context.");
  }

  const { data, error } = await supabase.rpc("afrimed_decide_patient_appointment_change", {
    p_request_id: cleanRequestId,
    p_decision: cleanDecision,
    p_correlation_id: String(correlationId || "").trim() || null,
  });
  if (error) throw error;
  return data || null;
}
